import { Button } from "@mui/material"
import { useSnackbar } from "notistack"
import Iconify from "minimals-template/components/Iconify"
import { confirm } from "lib/@dialogs/confirm"
import { hasDemand } from "lib/authorization/has-demand"
import { isEnabled } from "lib/@components/feature"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { AUTHORING_REVIEW_COMPONENT_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"
import { FEATURE_FLAG_COMPONENT_REVIEW } from "../../feature-flag-component-review"
import { approveMaintenanceTask } from "../../controller/approve-maintenance-task.controller"
import { useCameFromDrafts } from "../lib/use-came-from-drafts"
import { VIEW_DRAFTS } from "../lib/library-views"

export function ApproveTaskButton({ task }) {
    const { enqueueSnackbar } = useSnackbar()
    const { onSelectView } = useBoundContext()
    const cameFromDrafts = useCameFromDrafts()

    if (!isEnabled(FEATURE_FLAG_COMPONENT_REVIEW)) return null
    if (!task?.draft) return null
    if (!hasDemand(AUTHORING_REVIEW_COMPONENT_DEMAND)) return null

    return (
        <Button
            data-cy="approve-component-button"
            color="success"
            onClick={handleApprove}
            startIcon={<Iconify icon="eva:checkmark-circle-2-fill" />}
        >
            Approve
        </Button>
    )

    async function handleApprove() {
        if (
            !(await confirm("Approve this component? It will become available in searches and the component picker."))
        ) {
            return
        }

        await approveMaintenanceTask(task.id)
        enqueueSnackbar("Component approved", { variant: "success" })
        if (cameFromDrafts) onSelectView(VIEW_DRAFTS)
    }
}
